import * as React from 'react';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { localizations } from '../../localization/localization';

const styles = (theme: Theme) => createStyles({
    faqItem: {
        paddingTop: '1.5em',
        paddingLeft: '0.75em',
        paddingRight: '0.75em',
        '& > div:first-child': {
            fontSize: '1.25em',
            paddingTop: '1.2em',
            fontStyle: 'italic',
            fontWeight: 600,
            letterSpacing: '0.0355em',
            lineHeight: 1.4,
            marginBottom: '0.8em'

        },
        '& > div:last-child': {
            marginBottom: '0.625em',
            paddingTop: '1.2em',
            fontWeight: 600,
            letterSpacing: '0.0355em',
            lineHeight: 1.4,
        },
    },
    newsLink: {
        color: '#F7F8F9',
        marginRight: '1.25em',
        cursor: 'pointer',
        ontSize: '1.75em',
        paddingTop: '1.2em',
        textDecoration: 'underline'
    },
});

interface NewsItemProps {
    title: string;
    content: string;
    link: string;
    readMore: string;
}


const NewsItem: React.SFC<WithStyles & NewsItemProps> = ({
    classes,
    title,
    content,
    link,
    readMore
}) => {

    return (
        <Grid item container direction="column" className={classes.faqItem}>
            <Grid item>{title}</Grid>
            <Grid item>{content}</Grid>
            <Grid item>
                <a href={link} target="_blank" className={classes.newsLink} >
                    {readMore}
                </a>
            </Grid>
        </Grid>
    );
}

export default withStyles(styles)(NewsItem);



// WEBPACK FOOTER //
// ./src/landingPage/components/NewsItem.tsx